module.exports = __webpack_public_path__ + "img/a042ce7d0c0a193788b2708c48df834f.png";